/* SAOTO — Videos avis (UGC shoppable).
   Initialise le carousel Swiper existant. Ne s'exécute que si Swiper est
   chargé sur la page (l'app/section qui fournit Swiper doit être active). */
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.videosavis .mySwiper').forEach(function (el) {
    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      freeMode: true,
      breakpoints: {
        640: { slidesPerView: 'auto', spaceBetween: 20 },
        1024: { slidesPerView: 3, spaceBetween: 30 },
        1440: { slidesPerView: 3, spaceBetween: 40 }
      }
    });
  });
});

/* SAOTO — Miniatures personnalisées avant lecture (overlay), ajout du 06/09.
   S'applique uniquement aux blocs qui ont une miniature (voir sections/videosavis.liquid).
   Ne duplique aucune vidéo : agit sur le <video> déjà rendu par Shopify. */
document.addEventListener('DOMContentLoaded', function () {
  var cards = Array.prototype.slice.call(
    document.querySelectorAll('.videosavis [data-saoto-video-card]')
  );

  cards.forEach(function (card) {
    var video = card.querySelector('video');
    var overlay = card.querySelector('[data-saoto-video-overlay]');
    if (!video || !overlay) return;

    function playThisVideo() {
      cards.forEach(function (otherCard) {
        if (otherCard === card) return;
        var otherVideo = otherCard.querySelector('video');
        if (otherVideo && !otherVideo.paused) {
          otherVideo.pause();
        }
        otherCard.classList.remove('is-playing');
      });

      card.classList.add('is-playing');
      video.controls = true;

      var playResult = video.play();
      if (playResult && typeof playResult.catch === 'function') {
        playResult.catch(function () {
          card.classList.remove('is-playing');
          video.controls = false;
        });
      }
    }

    overlay.addEventListener('click', function (e) {
      e.preventDefault();
      playThisVideo();
    });

    video.addEventListener('ended', function () {
      card.classList.remove('is-playing');
      video.controls = false;
      video.currentTime = 0;
    });
  });
});
